module.exports = new __parcel__URL__("cornershop-ipad.cd5a7796.webp").toString();